/**
 * The set of severity types that are supported
 */
export var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity[AlertSeverity["HIGH"] = 1] = "HIGH";
    AlertSeverity[AlertSeverity["MODERATE"] = 2] = "MODERATE";
    AlertSeverity[AlertSeverity["LOW"] = 3] = "LOW";
})(AlertSeverity || (AlertSeverity = {}));
/**
 * For AlertRule's target, we will by default target all entities belonged to an entityClass. However, sometimes we don't want to target all
 * entities of an entityClass but we just want to target a smaller set of entities of that class. Therefore, we will allow the operator
 * to provide a filters to narrow down the target entities.
 */
export var EntityTarget;
(function (EntityTarget) {
    // Select entities that are children of some specific parents
    EntityTarget["PARENTS"] = "parents";
    // Select only some specific entities
    EntityTarget["ENTITIES"] = "entities";
})(EntityTarget || (EntityTarget = {}));
/**
 * The set of alert condition types that are supported
 */
export var AlertConditionType;
(function (AlertConditionType) {
    AlertConditionType["METRIC_HEARTBEAT"] = "metricsHeartbeat";
    AlertConditionType["METRIC_THRESHOLD"] = "metricsThreshold";
})(AlertConditionType || (AlertConditionType = {}));
/**
 * Type guard function to check if an obj is a METRICS alert condition e.g. MetricsHeartbeatAlertCondition or MetricsThresholdAlertCondition.
 */
export const isMetricsAlertCondition = (obj) => {
    const condition = obj;
    return condition && (condition.conditionType === AlertConditionType.METRIC_HEARTBEAT || condition.conditionType === AlertConditionType.METRIC_THRESHOLD);
};
/**
 * Type guard function to check if an obj is a MetricsHeartbeatAlertCondition
 */
export const isMetricsHeartbeatAlertCondition = (obj) => {
    const condition = obj;
    return condition.conditionType === AlertConditionType.METRIC_HEARTBEAT;
};
/**
 * Type guard function to check if an obj is a MetricsThresholdAlertCondition
 */
export const isMetricsThresholdAlertCondition = (obj) => {
    const condition = obj;
    return condition.conditionType === AlertConditionType.METRIC_THRESHOLD;
};
export var AlertRecipientType;
(function (AlertRecipientType) {
    AlertRecipientType["EMAIL"] = "email";
    AlertRecipientType["EVENT"] = "event";
})(AlertRecipientType || (AlertRecipientType = {}));
/**
 * Type guard to check if an object is an AlertRecipientEmail
 */
export const isEmailAlertRecipient = (obj) => {
    const recipient = obj;
    return recipient.recipientType === AlertRecipientType.EMAIL;
};
/**
 * Type guard to check if an object is an AlertRecipientEvent
 */
export const isEventAlertRecipient = (obj) => {
    const recipient = obj;
    return recipient.recipientType === AlertRecipientType.EVENT;
};
/**
 * Type of alerting states
 */
export var AlertState;
(function (AlertState) {
    AlertState[AlertState["ALERTING"] = 1] = "ALERTING";
    AlertState[AlertState["RECOVERED"] = 2] = "RECOVERED";
    // an Alert can be OBSOLETE when its Alert Condition is changed while it is in ALERTING state.
    AlertState[AlertState["OBSOLETE"] = 3] = "OBSOLETE";
    // an Alert can be INEFFECTIVE when the subject Entity has turned off monitoring while it is in ALERTING state.
    AlertState[AlertState["INEFFECTIVE"] = 4] = "INEFFECTIVE";
})(AlertState || (AlertState = {}));
export const isMetricsAlert = (obj) => {
    const alert = obj;
    return alert.condition !== undefined && isMetricsAlertCondition(alert.condition);
};
export const isMetricThresholdAlert = (obj) => {
    const alert = obj;
    return alert.condition !== undefined && isMetricsThresholdAlertCondition(alert.condition);
};
export const isMetricHeartbeatAlert = (obj) => {
    const alert = obj;
    return alert.condition !== undefined && isMetricsHeartbeatAlertCondition(alert.condition);
};
